import * as Style from "./styles";
import * as StyleGlobal from '../../shared/GlobalStyles/styles'
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from "react";
import { getToken, logout } from "../../services/auth";
import IconFreight from '../../assets/menuLateral/IconFreight.svg';
import { useCountTable } from "../../hooks/useCountTable";
import { useCountDelivery } from "../../hooks/useCountDelivery";
import { Navigation } from "../Navigation";
import { handleClickCloseModalGeneric, verifyMouse } from "../../functionsGlobal";
import { useContext } from "react";
import { DarkModeContext } from "../../contexts/darkMode";
import { useLoginContext } from "../../contexts/login";
import { Treeview } from "./Treeview";

export const SideBar = () => {
    const objectMenuDefault = [
        {
            id:'1',  disableLink:false,
            title: 'Gerenciamento e vendas', 
            isVisible:true,
            children:[]
        },
        {
            id:'2',
            disableLink:false,
            link: () => routers('/dashboard'),
            name: 'Início',
            isVisible: true,
            icon: ({theme}) => <Style.IconHome stroke={theme}/>,
            children:[]
        },
        {
            id:'3',
            disableLink:false,
            link: () => routers('/CarregarMesas'),
            name: 'Mesas',
            // isVisible: colorSvg ? false : true,
            isVisible: true,
            icon: ({theme}) => <Style.IconTable
            stroke={theme}
            fill={theme}
            />,
            children:[]
        },
        {
            id:'4',
            disableLink:false,
            link: () => routers('/Delivery'),
            name: 'Delivery',
            isVisible: true,
            icon: ({theme}) => <Style.IconDelivery stroke={theme}/>,
            children:[]
        },
        {
            id:'5',
            disableLink:false,
            link: () => routers('/AdicionarProdutoVenda'),
            name: 'Venda',
            isVisible: true,
            icon: ({theme}) =>  <Style.IconConsultSales fill={theme}/>,
            children:[]
        },
        {
            id:'6', disableLink:false, name: 'DF-e',  isVisible: true, icon: ({theme}) =>  <Style.IconDfe fill={theme}/>, 
            children:[
                {id:'6.1',  disableLink:false,link: () => routers('/AdicionarProdutoNFCE'), name: 'NFC-e',  isVisible: true, icon: ({theme}) =>  <Style.IconConsultSales fill={theme}/> },
                {id:'6.2', disableLink:false, link: () => routers('/AdicionarProdutoEntradaNFE'), name: 'NF-e Entrada',  isVisible: true, icon: ({theme}) => <Style.IconNfe  fill={theme}/>},
                {id:'6.7', disableLink:false, link: () => routers('/AdicionarProdutoSaidaNFE'), name: 'NF-e Saída',  isVisible: true, icon: ({theme}) => <Style.IconNfe  fill={theme}/>},
            ]
        },

        {id:'7',  disableLink:false,link: () => routers('/listarVendas'), name: 'Consultar Vendas',  isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconOrder fill={theme}/> },
        {id:'8',  disableLink:false,link: () => routers('/AdicionarProdutoEntrada'), name: 'Entrada de Nota',  isVisible: true, icon: ({theme}) =>  <Style.IconNoteEntry  fill={theme}/> },
        {id:'9',  disableLink:false,link: () => routers('/listarNotasEntrada'), name: 'Consultar Entrada',  isVisible: true, icon: ({theme}) =>  <Style.IconConsultNoteEntry fill={theme}/> }, 
        {id:'10', disableLink:false, title: 'Configurações da Loja', isVisible:true},
        {id:'11', disableLink:false, name: 'Itens',  isVisible: true, icon: ({theme}) =>  <Style.IconItems fill={theme}/>, 
        children:[
            {id:'11.1', disableLink:false, link: () => routers('/listarProduto'), name: 'Itens', isVisible: true, icon: ({theme}) =>  <Style.IconItems fill={theme}/>},
            {id:'11.2', disableLink:false, link: () => routers('/listarComplemento'), name: 'Complementos', isVisible: true, icon: ({theme}) =>  <Style.IconComplement fill={theme}/> },
            {id:'11.3', disableLink:false, link: () => routers('/listarGrupoComplemento'), name: 'Grupo de complementos', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconGroupComplement fill={theme} />},
            {id:'11.4', disableLink:false, link: () => routers('/listarFabricante'), name: 'Fabricante', isVisible: true, icon: ({theme}) =>  <Style.IconPerson fill={theme}/>},
            {id:'11.5', disableLink:false, link: () => routers('/listarSecao'), name: 'Seção', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconSection fill={theme}/>},
            {id:'11.6', disableLink:false, link: () => routers('/listarNcm'), name: 'NCM', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconNcm fill={theme}/>},
            {id:'11.7', disableLink:false, link: () => routers('/listarCfop'), name: 'CFOP', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconCfop fill={theme}/>},
            {id:'11.8', disableLink:false, link: () => routers('/listarEtiqueta'), name: 'Etiqueta', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconLabel fill={theme}/>}
        ]
        },
        {id:'12', disableLink:false, name: 'Estoque',  isVisible: true, icon: ({theme}) =>  <Style.IconStock fill={theme}/>, 
        children:[
            {id:'12.1', disableLink:false, link: () => routers('/NotaAvulsa'), name: 'Entrada / Saída Avulsa', isVisible: true, icon: ({theme}) =>  <Style.IconNoteSingle fill={theme}/>},
            {id:'12.2', disableLink:false, link: () => routers('/Inventario'), name: 'Inventário', isVisible: true, icon: ({theme}) =>  <Style.IconInventory fill={theme}/> }]
        },
        {id:'13', disableLink:false, name: 'Pessoas',  isVisible: true, icon: ({theme}) => <Style.IconPerson fill={theme}/>, 
        children:[
            {id:'13.1', disableLink:false, link: () => routers('/listarCliente'), name: 'Clientes', isVisible: true, icon: ({theme}) => <Style.IconPerson fill={theme}/>},
            {id:'13.2', disableLink:false, link: () => routers('/carregarAtendente'), name: 'Atendentes', isVisible: true, icon: ({theme}) =>  <Style.IconAttendant 
                fill={theme}
                stroke={theme}
            /> },
            {id:'13.3', disableLink:false, link: () => routers('/listarEntregador'), name: 'Entregador', isVisible: true, icon: ({theme}) =>  <Style.IconDeliveryMan fill={theme} />  },
            {id:'13.4', disableLink:false, link: () => routers('/listarUsuario'), name: 'Usuários', isVisible: true, icon: ({theme}) =>   <Style.IconUser 
                fill={theme}
                stroke={theme}
            />},
        ]},
        {id:'14', disableLink:false, name: 'Financeiro',  isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconPayment fill={theme}/>, 
        children:[
            {id: '14.1', disableLink:false, link: () => routers('/listarFormaPagamento'), name: 'Forma de Pagamento', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconCard fill={theme}/>},
            {id:'14.2', disableLink:false, link: () => routers('/listarReceita'), name: 'Receita', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconGraphUp fill={theme}/>},
            {id:'14.3', disableLink:false, link: () => routers('/listarDespesa'), name: 'Despesa', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconGraphDown fill={theme}/>},
            {id:'14.4', disableLink:false, link: () => routers('/listarContaCorrente'), name: 'Conta Corrente', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconCurrentAccount fill={theme}/>},
            {id:'14.5', disableLink:false, link: () => routers('/listarContasPagar'), name: 'Contas a Pagar', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconBillsToPay fill={theme}/>},
            {id:'14.6', disableLink:false, link: () => routers('/listarContasReceber'), name: 'Contas a Receber', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconBillsToReceive fill={theme}/>},
            {id:'14.7', disableLink:false, link: () => routers('/listarSangriaSuprimento'), name: 'Sangria e Suprimento', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconSangriaAndSupply fill={theme}/>},
            {id:'14.7', disableLink:false, link: () => routers('/listarValeTroca'), name: 'Vale troca', isVisible: true, icon: ({theme}) =>  <StyleGlobal.IconWorthExchange fill={theme}/>},
        ]},
        {id:'15', disableLink:false, link: () => routers('/listarFrete'), name: 'Frete', isVisible: true, icon: ({theme}) =>  <img src={IconFreight} alt='ícone de frete'/> },
        {id:'16', disableLink:false, title: 'Configurações', isVisible:true},
        {id:'17', disableLink:false, link: () => routers('/parametro'), name: 'Configurações', isVisible: true, icon: ({theme}) =>  <Style.IconSettings fill={theme}/> },
        {id:'18', disableLink:false, link: () => routers('/QrCode'), name: 'App', isVisible: true, icon: ({theme}) => <Style.IconApp fill={theme}/>}
    ]

    const objectMenuTeleSales = [
        {
            id:'19',
            disableLink:false,
            link: () => routers('/Televendas'),
            name: 'Televendas',
            isVisible: true,
            icon: ({theme}) => <StyleGlobal.IconTeleSales fill={theme}/> ,
            children:[]
        },
        {
            id:'19.1',
            disableLink:false,
            link: () => routers('/listarProdutoTelevendas'),
            name: 'Produtos',
            isVisible: true,
            icon: ({theme}) => <StyleGlobal.IconItems fill={theme}/>,
            children:[]
        },
        {
            id:'13', disableLink:false, name: 'Pessoas',  isVisible: true, icon: ({theme}) => <Style.IconPerson fill={theme}/>, 
            children:[
                {id:'13.1', disableLink:false, link: () => routers('/listarCliente'), name: 'Clientes', isVisible: true, icon: ({theme}) => <Style.IconPerson fill={theme}/>},
                {id:'13.4', disableLink:false, link: () => routers('/listarUsuario'), name: 'Usuários', isVisible: true, icon: ({theme}) =>   <Style.IconUser 
                    fill={theme}
                    stroke={theme}
                />},
            ]
        }
    ]
    const history = useHistory();
    const {countTable} = useCountTable();
    const {coutDelivery} = useCountDelivery();
    const [openSidebar, setopenSideBar] = useState(true);
    const colorSvg = JSON.parse(getToken('SISTESHOP'));
    const sideBar = JSON.parse(getToken('SIDEBAR'));
    const {reloadSidebar} = useLoginContext()
    const {darkModeButton, verifySisteShop, selectedTheme, verifySisteShopIcon} = useContext(DarkModeContext)
    const {typeFreight} = useLoginContext()
    const [menuSidebar, setMenuSidebar] = useState([...objectMenuDefault])
    
    const routers = (value) => {
        history.push(value); 
        if(window.innerWidth <= 780) setopenSideBar(false);
    }   

    const logoutSystem = () => {
        logout('ID_USUARIO');
        logout('CNPJ');
        logout('LOGIN');
        logout('NOMEEMPRESA');
        logout('DIAS');
        logout('ADM');
        logout('RULESPERMISSIONUSER');
        logout('SENDEMAIL');
        logout('COMPANIES');
        logout('SIDEBAR');
        logout('ID_VENDEDOR');
        logout('IMPORTDELIVERYORTABLE');
        history.push('/')
    }

    useEffect(() => {
        verifyOnRizise();
        verifyMediaQueryWidth();
        return () => { window.removeEventListener('resize', verifyWidth);}
    },[])

    useEffect(() => {
        if(typeFreight && ( !sideBar )){
            const newElement = objectMenuDefault.map(item => {
                if(item.id === '15') item.isVisible = typeFreight?.value_freight ? false : (typeFreight?.locality || typeFreight?.ray) ?? false
                return item
            })
            setMenuSidebar([...newElement])
        }

    }, [typeFreight, sideBar])

    useEffect(() => {
        if(reloadSidebar) setMenuSidebar([...objectMenuDefault])
        else if (sideBar?.televendas) {
            setMenuSidebar([...objectMenuTeleSales])
        }
    }, [reloadSidebar, sideBar?.televendas])


    const verifyMediaQueryWidth = () => {
        if(window.innerWidth <= 1280){
            if (openSidebar)setopenSideBar(false);
        }
    }

    const verifyWidth = () => {
        if(window.innerWidth <= 1280) setopenSideBar(false);
        else setopenSideBar(true);
    }

    const verifyOnRizise = () => window.addEventListener('resize', verifyWidth)

    const verifyIfMouseEnterInNavigationRoot = () => {
        if(window.innerWidth <= 1280){
            if(!openSidebar) setopenSideBar(true);
        }
    }    

    const verifyIfMouseLeaveInNavigationRoot = () => { 
        if(window.innerWidth <= 1280 && window.innerWidth > 768){
            if(openSidebar) setopenSideBar(false);
        }
    }

    return( 
        <>
            <Style.IconCloseSidBar onClick={() => setopenSideBar(!openSidebar)}>
                <Style.IconCloseSidBarSvg stroke={colorSvg ? darkModeButton ? verifySisteShop() : selectedTheme.backgrounds.blue : darkModeButton ? verifySisteShopIcon() :selectedTheme.backgrounds.blue4 }/>
            </Style.IconCloseSidBar>
            
            <Style.ContainerSidabar openSidebar={openSidebar} id={'modal-generic'}
                onMouseUp={(event) => verifyMouse(event, handleClickCloseModalGeneric,   () => setopenSideBar(false))}
                onMouseDown={(event) => verifyMouse(event, handleClickCloseModalGeneric, () => setopenSideBar(false))}
            >
                
                <Navigation.Root openSidebar={openSidebar}  onMouseEnter={verifyIfMouseEnterInNavigationRoot}
                    onMouseLeave={verifyIfMouseLeaveInNavigationRoot}
                >
                    <Navigation.ListItem >
                        {
                            menuSidebar.length > 0 && (
                                <Treeview 
                                    tree={menuSidebar} 
                                    colorSvg={colorSvg} 
                                    openSidebar={openSidebar}
                                    coutDelivery={coutDelivery}
                                    countTable={countTable}
                                    darkModeButton={darkModeButton}
                                    selectedTheme={selectedTheme}
                                />
                            )
                        }
                    </Navigation.ListItem>
                    <Style.BoxFooter openSidebar={openSidebar} onClick={logoutSystem} themeColor={darkModeButton ? '#272a2c' : ''}>
                        <Style.IconLogout 
                            fill={colorSvg ?  darkModeButton ? verifySisteShop() : selectedTheme.backgrounds.blue :   darkModeButton ? verifySisteShopIcon() :selectedTheme.backgrounds.blue4}
                            stroke={colorSvg ?  darkModeButton ? verifySisteShop() : selectedTheme.backgrounds.blue : darkModeButton ? verifySisteShopIcon() :selectedTheme.backgrounds.blue4}
                        />
                        { openSidebar && <p>Sair</p>}
                    </Style.BoxFooter>
                </Navigation.Root>
            </Style.ContainerSidabar>
        </>

    )
}